import { sendWebsocketMessage } from '../../../../../../App';

export function flattenAllTradePlans(){
  const msg = {
    messageType: 'flattenAllTradePlans'
  };

  sendWebsocketMessage(msg);
}
